/**
 * DBS external entry points — employer-authorised operations only.
 *
 * The Update Service is solely for a subscribed, eligible Standard/Enhanced
 * certificate. Care Check's entry is a NEW application, not a status check.
 * A browser visit here never marks an applicant verified or creates a payment.
 *
 * URLs are stable starting pages, not session-scoped continuation links.
 */
import { DBS_APPLICANT_START_URL } from './dbsApplicantMessage';

export const DBS_UPDATE_STATUS_CHECK_URL = 'https://secure.crbonline.gov.uk/crsc/check';

export const DBS_CHECK_ROUTE_LINKS = Object.freeze([
  {
    kind: 'existing_update_service',
    label: 'Check subscribed DBS certificate',
    url: DBS_UPDATE_STATUS_CHECK_URL,
    description: 'For an existing eligible DBS certificate with an active Update Service subscription. Check consent, original certificate, identity and relevant workforce first.',
  },
  {
    kind: 'new_carecheck_application',
    label: 'New DBS application — Care Check',
    url: DBS_APPLICANT_START_URL,
    description: 'Applicant entry only. Osabea must first authorise the new check and provide its own organisation reference. The applicant completes their application.',
  },
]);
